import {Injectable} from '@angular/core';

@Injectable()

export class UtilsService {
  createNowReleaseString(): string {
    let now: Date = new Date(Date.now());
    let month: string = this.formatDateTime(now.getMonth() + 1);
    let day: string = this.formatDateTime(now.getDate());
    let hour: string = this.formatDateTime(now.getHours());
    let minutes = '00';
    let seconds = '00';
    let dateString: any = `${now.getFullYear()}-${month}-${day}`;
    let timeString: any = `${hour}:${minutes}`;
    return `${dateString}T${timeString}:${seconds}`;
  }

  formatDateTime(int: number): string {
    let measure: string;
    if (int < 10) {
      measure = `0${int}`;
    } else {
      measure = int.toString();
    }
    return measure;
  }

}


// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/utils.service.ts